export enum SteeringWheelLocationEnum {
  Left = 'left',
  Right = 'right',
}
